import {
  EApiDatafanProgressType,
  EApiDatafanStreamReportStatus,
  IApiDatafanStreamReportStatus,
} from "@smp/api";

import { aggregateDatafanProgressValue } from "./aggregate_datafan_progress_value";

interface IAggregatedProgress {
  sign: string;
  stepCurrent: number;
  stepTotal: number;
  name: string;
  value: string | number;
  type: EApiDatafanProgressType | null;
}

export const aggregateDatafanReportStatusProgress = (
  reportStatus: IApiDatafanStreamReportStatus[],
): IAggregatedProgress => {
  const { finishedStreamProgress, currentStreamProgress } = reportStatus.reduce(
    (
      acc: {
        currentStreamProgress: null | IApiDatafanStreamReportStatus;
        finishedStreamProgress: null | IApiDatafanStreamReportStatus;
      },
      reportStatus,
    ) => {
      if (reportStatus.status === EApiDatafanStreamReportStatus.LOCK) {
        acc.currentStreamProgress = reportStatus;
      } else if (
        reportStatus.status === EApiDatafanStreamReportStatus.SUCCESS
      ) {
        acc.finishedStreamProgress = reportStatus;
      }

      return acc;
    },
    {
      currentStreamProgress: null,
      finishedStreamProgress: null,
    },
  );

  return reportStatus.reduce(
    (acc: IAggregatedProgress, reportStatus) => {
      acc.stepTotal += reportStatus.progress?.total_items || 0;

      if (reportStatus.status === EApiDatafanStreamReportStatus.SUCCESS) {
        acc.stepCurrent += reportStatus.progress?.total_items || 0;
      } else if (reportStatus.status === EApiDatafanStreamReportStatus.LOCK) {
        acc.stepCurrent += reportStatus.progress?.current_item_num || 1;
      }

      const { progress } =
        currentStreamProgress || finishedStreamProgress || {};

      if (progress) {
        const item = progress?.items[progress.current_item_sign];

        acc.sign = item.sign;
        acc.type = item.type;

        if (item) {
          acc.name = item.name;
          acc.value = aggregateDatafanProgressValue(progress);
        }
      }

      return acc;
    },
    {
      name: "",
      sign: "",
      stepCurrent: 0,
      stepTotal: 0,
      type: null,
      value: "",
    },
  );
};
